import { createStyles } from "@mantine/emotion";

export default createStyles ( () => {
	return ( {
		avatar: {
			borderRadius : "100%",
			height       : "4rem",
			width        : "4rem"
		}
	} );
} );